import React from 'react';
import { WordItem } from '../types';
import { CustomWordItem } from '../utils/customVocabularyStorage';
import { UnifiedQuizChallengeModal } from './UnifiedQuizChallengeModal';

interface CustomQuizChallengeModalProps {
  customWords: CustomWordItem[];
  allWords: WordItem[];
  onClose: () => void;
  onAddScore?: (xp: number) => void;
}

export const CustomQuizChallengeModal: React.FC<CustomQuizChallengeModalProps> = ({
  customWords,
  allWords,
  onClose,
  onAddScore,
}) => {
  return (
    <UnifiedQuizChallengeModal
      title="Quizz Vocabulaire Personnalisé"
      subtitle="Pratiquez vos mots ajoutés"
      icon="✨"
      words={customWords}
      allWords={allWords}
      onClose={onClose}
      onAddScore={onAddScore}
      initialHearts={5}
    />
  );
};
